import { TestGroupGate } from "../gate/TestGroupGate";

export const TestGroupBanner = () => {
  return (
    <TestGroupGate>
      <div className="bg-accent w-full p-1 text-center text-xs font-bold text-white">
        Test Group
      </div>
    </TestGroupGate>
  );
};
